module.exports = __webpack_public_path__ + "img/member_list_1.54f30d95.png";